<mat-toolbar color="primary" style="font-size: 1.2em">
  <span>Field Allocation</span>
  <span class="spacer"></span>
  <!-- Reload data:
  <button mat-icon-button (click)="refresh()">
    <mat-icon>refresh</mat-icon>
  </button> -->
</mat-toolbar>

<div class="example-container mat-elevation-z8">
  <!-- <div class="form">
  <mat-form-field floatPlaceholder="never" color="accent">
    <input matInput #filter placeholder="Filter">
  </mat-form-field>
</div> -->

  <mat-table #table [dataSource]="dataSource" matSort class="mat-cell">
    @for (col of displayColumnsWithCatchIndex; track col) {
    <div>
      @if (col && col.name != 'actions') {
      <ng-container matColumnDef="{{ col.name }}">
        <mat-header-cell *matHeaderCellDef mat-sort-header> {{ col.header }}</mat-header-cell>
        <mat-cell *matCellDef="let row">
          @if (col.type === 'text' && row[col.name]) {
          <div>
            {{ row[col.name] }}
          </div>
          } @if (col.type === 'dropdown' && row[col.name]) {
          <div #colName>
            {{ row[col.name].name }}
          </div>
          } @if (col.type === 'color' && row[col.name]) {
          <div>
            <label for="colName" style="width: 50px; height: 20px" [style.background-color]="row[col.name]"></label>
          </div>
          }
        </mat-cell>
        <!-- /<mat-cell *matCellDef="let row"> {{row[col.name]}} </mat-cell> -->
      </ng-container>
      }
    </div>
    }

    <ng-container matColumnDef="actions">
      <mat-header-cell *matHeaderCellDef>
        <button mat-icon-button color="primary" (click)="addRecord()" *ngIf="!isReadOnly">
          <mat-icon aria-label="Example icon-button with a heart icon">add</mat-icon>
        </button>
      </mat-header-cell>

      <mat-cell *matCellDef="let row">
        <button mat-icon-button color="accent" (click)="editRecord(row)" *ngIf="!isReadOnly">
          <mat-icon aria-label="Edit">edit</mat-icon>
        </button>

        <button mat-icon-button color="accent" (click)="deleteRecord(row)" *ngIf="!isReadOnly">
          <mat-icon aria-label="Delete">delete</mat-icon>
        </button>

        <button mat-icon-button color="accent" (click)="rowUp(row)" *ngIf="!isReadOnly">
          <mat-icon aria-label="arrow_drop_up">arrow_drop_up</mat-icon>
        </button>
        <button mat-icon-button color="accent" (click)="rowDown(row)" *ngIf="!isReadOnly">
          <mat-icon aria-label="arrow_drop_down">arrow_drop_down</mat-icon>
        </button>
      </mat-cell>
    </ng-container>

    <mat-header-row *matHeaderRowDef="displayColumnsWithOutCatchIndex"></mat-header-row>
    <mat-row *matRowDef="let row; columns: displayColumnsWithOutCatchIndex"></mat-row>
  </mat-table>

  <div class="no-results" [style.display]="dataSource?.renderedData?.length === 0 ? '' : 'none'">No results</div>

  <!-- <mat-paginator #paginator [length]="dataSource.filteredData.length" [pageIndex]="0" [pageSize]="10" [pageSizeOptions]="[5, 10, 25, 100]">
</mat-paginator> -->
  <mat-paginator [length]="dataService.dataChange.value.length" [pageSize]="10" [pageIndex]="0"> </mat-paginator>
</div>
